define.alias("ember-composable-helpers/helpers/map", "settings/helpers/map");